<div class='row no-gutters'>
    <div class="col-4 messages-list">
        <app-view-side-messages-titles (onSortTable)="onSortTable($event)" (onScrollList)='onScroll($event)'
            [messagesTitles]='messagesTitles'></app-view-side-messages-titles>
    </div>
    <div class="col-8">
        <div class="row message-details-container">
            <div class="message-info">
                <app-view-message-details [messageDetails]='messageDetails'></app-view-message-details>
            </div>
            <div class="message-content">
                <app-view-message-content [messageContent]='safeHTML'>
                </app-view-message-content>
            </div>
        </div>
    </div>
</div>